import { render, staticRenderFns } from "./title-1.vue?vue&type=template&id=dbbc9b0a&scoped=true"
import script from "./title-1.vue?vue&type=script&lang=js"
export * from "./title-1.vue?vue&type=script&lang=js"
import style0 from "./title-1.vue?vue&type=style&index=0&id=dbbc9b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbc9b0a",
  null
  
)

export default component.exports